<template>
  <v-card color="rgba(0,0,0,0)" flat>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Benestare </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone per il trasferimento -->
      <v-btn
        @click="clickQRCode('trasferimento')"
        height="120px"
        color="white"
        class="mr-10"
      >
        <div>
          <v-icon class="mb-3" size="50px">mdi-qrcode-scan</v-icon><br />
          <span style="font-size: 20px">Presenta QR code</span>
        </div>
      </v-btn>

      <!-- Bottone per la chiusura -->
      <v-btn @click="clickQRCode('chiusura')" height="120px" color="white">
        <div>
          <v-icon class="mb-3" size="50px">mdi-file-edit-outline</v-icon><br />
          <span style="font-size: 20px">Chiudi Commessa</span>
        </div>
      </v-btn>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers_benestare"
            :items="items_benestare"
          ></v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog del lettore QR code -->
    <v-dialog v-model="qr_reader_visible" width="75%" persistent>
      <v-toolbar
        dense
        style="
          background-color: rgba(255, 255, 255, 0.13);
          backdrop-filter: blur(8px);
          color: white;
          box-shadow: 0 0 40px rgba(8, 7, 16, 0.6);
        "
      >
        <v-toolbar-title>QR Master</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small v-bind="attrs" v-on="on">
              <v-icon @click="handleCloseQRDialog" color="error">
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <qrcode-stream :camera="camera" @decode="handleOnDecode"></qrcode-stream>
    </v-dialog>

    <!-- Dialog di conferma spostamento -->
    <v-dialog v-model="dialog_conferma_spostamento" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler dare il benestare per il trasferimento di
            {{ qta_commessa }} {{ des_um_commessa ?? "unità" }}?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_spostamento = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eseguiSpostamento" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma chiusura a seguito di spostamento -->
    <v-dialog v-model="dialog_conferma_chiusura" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            La commessa abbinata al seriale può essere chiusa. Vuoi procedere?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_chiusura = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="chiudiCommessa" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "Benestare",
  components: { SnackbarQV },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      camera: "off",
      des_um_commessa: null,
      modalita: "",
      qr_string: "",
      qta_commessa: null,
      id_articolo_chiusura: null,
      id_commessa_chiusura: null,
      id_stato_chiusura: null,

      // Modal
      dialog_conferma_chiusura: false,
      dialog_conferma_spostamento: false,
      overlay: false,
      qr_reader_visible: false,

      // Array
      items_benestare: new Array(),
      headers_benestare: [
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
        },
        {
          text: "Commessa",
          value: "cod_commessa",
        },
        {
          text: "Seriale",
          value: "cod_commessa",
        },
        {
          text: "Quantità",
          value: "quantita",
        },
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    checkChiusura(arg) {
      const seriale = arg.split("(S)")[1].split(";")[0];

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "checkchiusuratrasferimento",
          token: localStorage.user_token,
          seriale: seriale,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.result[0].chiusura_disponibile == 1) {
              this.id_commessa_chiusura = res.data.result[0].id_commessa;
              this.id_articolo_chiusura = res.data.result[0].id_articolo;
              this.dialog_conferma_chiusura = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    checkQRCodeSAP(arg) {
      const cod_articolo = arg.split("(P)")[1].split(";")[0];
      const seriale = arg.split("(S)")[1].split(";")[0];

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "checkqrcodesap",
          token: localStorage.user_token,
          cod_articolo: cod_articolo,
          seriale: seriale,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.qta_commessa = res.data.result[0].quantita;
            this.des_um_commessa = res.data.result[0].des_um;
            this.dialog_conferma_spostamento = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            JSON.parse(err?.response?.data?.message)?.result
          );
        });
    },
    chiudiCommessa() {
      this.dialog_conferma_chiusura = false;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_articolo: this.id_articolo_chiusura,
          id_commessa: this.id_commessa_chiusura,
          id_profilo: localStorage.id_profilo,
          tabella: [
            {
              commessa: [
                {
                  id_commessa: this.id_commessa_chiusura,
                  id_stato: this.id_stato_chiusura,
                },
              ],
              commessa_dettaglio: [],
              commessa_distinta: [],
            },
          ],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Commessa chiusa");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            JSON.parse(err?.response?.data?.message)?.result
          );
        });
    },
    clickIndietro() {
      this.$router.push("/home/production");
    },
    clickQRCode(arg) {
      this.modalita = arg;

      // Resetto le variabili.
      this.qr_string = "";
      this.qta_commessa = null;
      this.des_um_commessa = null;
      this.id_articolo_chiusura = null;
      this.id_commessa_chiusura = null;

      // Attivo la videocamera.
      this.qr_reader_visible = true;
      this.camera = "auto";
    },
    async eseguiSpostamento() {
      this.dialog_conferma_spostamento = false;
      const spostamento = await this.spostaInMagazzinoSap(this.qr_string);

      if (spostamento) {
        this.checkChiusura(this.qr_string);
      }
    },
    getBenesrtareInsit() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getbenestareinsit",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_benestare = res.data.result ?? [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    getTabella() {
      /* Questa gettabelle mi serve sostanzialmente per
       * essere in grado di riconoscere il tipo di domanda
       * con cui sto lavorando, in modo da configurare debitamente
       * i contenuti dei dialog. */
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "COMMESSA_STATO",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Popolo l'array dei tipi di domanda
            this.id_stato_chiusura = res.data.filter(
              (elem) => elem.val_txt == "3"
            )[0]?.id_tabella;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità tecnica rilevata, codice: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    handleCloseQRDialog() {
      this.qr_reader_visible = false;
      this.camera = "off";
    },
    handleOnDecode(arg) {
      if (this.modalita == "trasferimento") {
        this.handleOnDecodeTrasferimento(arg);
      } else if (this.modalita == "chiusura") {
        this.handleOnDecodeChiusura(arg);
      }
    },
    handleOnDecodeChiusura(arg) {
      this.qr_string = arg;
      this.camera = "off";
      this.qr_reader_visible = false;

      this.checkChiusura(this.qr_string);
    },
    handleOnDecodeTrasferimento(arg) {
      this.qr_string = arg;
      this.camera = "off";
      this.qr_reader_visible = false;

      this.checkQRCodeSAP(this.qr_string);
    },
    spostaInMagazzinoSap(arg) {
      const cod_articolo = arg.split("(P)")[1].split(";")[0];
      const seriale = arg.split("(S)")[1].split(";")[0];
      const tipo = arg.split("(T)")[1].split(";")[0];

      // Controllo che l'etichetta sia un master.
      if (tipo != "MASTER") {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'etichetta non è di tipo master."
        );
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "spostainmagazzinosap",
          token: localStorage.user_token,
          cod_articolo: cod_articolo,
          seriale: seriale,
        },
      };

      this.overlay = true;

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Trasferimento avvenuto con successo."
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            JSON.parse(err?.response?.data?.message)?.result
          );
          return false;
        });
    },
  },
  created() {},
  mounted() {
    this.getTabella();
    this.getBenesrtareInsit();
  },
};
</script>
<style scoped>
</style>